/**
 * Schools-related database operations
 */

/**
 * Get all schools with their classrooms and resources
 * @param {EduQuizDB} db - Database instance
 * @returns {Promise<Array>} Schools hierarchy with classrooms and resource assignments
 */
export async function getSchoolsHierarchy(db) {
    try {
        const schools = await db.schools.toArray();

        // Build hierarchy
        const hierarchy = await Promise.all(
            schools.map(async (school) => {
                // Get classrooms for this school
                const classrooms = await db.classrooms
                    .where("schoolId")
                    .equals(school.serverId)
                    .toArray();

                // For each classroom, get resource assignments
                const classroomsWithResources = await Promise.all(
                    classrooms.map(async (classroom) => {
                        const assignments = await db.resourceAssignments
                            .where("classroomId")
                            .equals(classroom.serverId)
                            .toArray();

                        return {
                            ...classroom,
                            resources: assignments,
                        };
                    }),
                );

                return {
                    ...school,
                    classrooms: classroomsWithResources,
                };
            }),
        );

        return hierarchy;
    } catch (error) {
        console.error("Failed to get schools hierarchy:", error);
        throw error;
    }
}
